import { useEffect, useRef, useState } from "react";
import { useMotionRail } from "./MotionRailProvider";

/**
 * Terracotta dot that stretches into a short bar when hovering elements
 * marked with [data-magnetic]. Disabled on touch + reduced-motion.
 */
export function MagneticCursor() {
  const dotRef = useRef<HTMLDivElement>(null);
  const [hot, setHot] = useState(false);
  const [active, setActive] = useState(false);
  const { reduced } = useMotionRail();

  useEffect(() => {
    if (reduced) return;
    const isTouch =
      typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;
    if (isTouch) return;
    setActive(true);

    let raf = 0;
    let tx = -100;
    let ty = -100;
    let cx = -100;
    let cy = -100;

    const onMove = (e: MouseEvent) => {
      tx = e.clientX;
      ty = e.clientY;
      const t = e.target as HTMLElement | null;
      const isHot = !!t?.closest("a, button, [data-magnetic]");
      setHot(isHot);
    };
    const tick = () => {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
    };
  }, [reduced]);

  if (!active) return null;
  return (
    <div
      ref={dotRef}
      className="magnetic-cursor"
      data-hot={hot ? "true" : "false"}
      aria-hidden="true"
    />
  );
}

export default MagneticCursor;
